import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ServicoRastreamentoBio {
  private readonly CHAVE_SESSAO = 'bio_pagina_visualizacao_rastreada';
  private readonly CHAVE_DEBOUNCE_CLIQUE = 'bio_last_click';
  private readonly TEMPO_DEBOUNCE_CLIQUE_MS = 1000;
  private readonly CHAVE_VISITOR_ID = 'bio_visitor_id';
  private readonly CHAVE_SESSION_ID = 'bio_session_id';
  private readonly CHAVE_ORIGEM = 'bio_origem';

  private readonly REFERRER_MAP: {[key: string]: string} = {
    'instagram.com': 'instagram',
    'l.instagram.com': 'instagram',
    'whatsapp.com': 'whatsapp',
    'wa.me': 'whatsapp',
    'web.whatsapp.com': 'whatsapp',
    'facebook.com': 'facebook',
    'fb.com': 'facebook',
    'l.facebook.com': 'facebook',
    'm.facebook.com': 'facebook',
    'tiktok.com': 'tiktok',
    'google.com': 'google',
    'google.com.br': 'google',
    'twitter.com': 'twitter',
    'x.com': 'twitter',
    't.co': 'twitter'
  };

  registrarVisualizacaoPagina(slug: string): void {
    if (this.ehAdmin()) return;

    const chaveSessao = this.CHAVE_SESSAO + '_' + slug;
    try {
      if (sessionStorage.getItem(chaveSessao)) return;
    } catch (e) {}

    setTimeout(() => {
      const dados = this.construirDadosEvento('visualizacao', 'pagina', null);
      this.enviarEvento(slug, dados);

      try {
        sessionStorage.setItem(chaveSessao, '1');
      } catch (e) {}
    }, 300);
  }

  registrarClique(slug: string, tipoItem: string, idItem: number | null, titulo?: string, posicao?: number): void {
    if (this.ehAdmin()) return;

    const chaveClique = `${tipoItem}_${idItem}`;
    try {
      const ultimoClique = sessionStorage.getItem(this.CHAVE_DEBOUNCE_CLIQUE);
      if (ultimoClique) {
        const parsed = JSON.parse(ultimoClique);
        if (parsed.key === chaveClique && (Date.now() - parsed.time) < this.TEMPO_DEBOUNCE_CLIQUE_MS) {
          return;
        }
      }
      sessionStorage.setItem(this.CHAVE_DEBOUNCE_CLIQUE, JSON.stringify({
        key: chaveClique,
        time: Date.now()
      }));
    } catch (e) {}

    const dados = this.construirDadosEvento('clique', tipoItem, idItem);
    if (titulo) dados.tituloItem = titulo;
    if (posicao != null) dados.posicaoItem = posicao;

    this.enviarEvento(slug, dados);
  }

  private construirDadosEvento(tipoEvento: string, tipoItem: string, idItem: number | null): any {
    const origem = this.detectarOrigem();
    return {
      tipoEvento: tipoEvento,
      tipoItem: tipoItem,
      idItem: idItem,
      visitorId: this.obterVisitorId(),
      sessionId: this.obterSessionId(),
      origem: origem,
      referrer: this.obterReferrer(),
      utmSource: this.obterParametroUrl('utm_source'),
      utmMedium: this.obterParametroUrl('utm_medium'),
      utmCampaign: this.obterParametroUrl('utm_campaign'),
      dispositivo: this.detectarDispositivo(),
      userAgent: this.obterUserAgent()
    };
  }

  private obterVisitorId(): string {
    try {
      let id = localStorage.getItem(this.CHAVE_VISITOR_ID);
      if (!id) {
        id = this.gerarUUID();
        localStorage.setItem(this.CHAVE_VISITOR_ID, id);
      }
      return id;
    } catch (e) {
      return this.gerarUUID();
    }
  }

  private obterSessionId(): string {
    try {
      let id = sessionStorage.getItem(this.CHAVE_SESSION_ID);
      if (!id) {
        id = this.gerarUUID();
        sessionStorage.setItem(this.CHAVE_SESSION_ID, id);
      }
      return id;
    } catch (e) {
      return this.gerarUUID();
    }
  }

  private detectarOrigem(): string {
    try {
      const origemSalva = sessionStorage.getItem(this.CHAVE_ORIGEM);
      if (origemSalva) return origemSalva;
    } catch (e) {}

    let origem = 'direto';

    try {
      const params = new URLSearchParams(window.location.search);
      const utmSource = params.get('utm_source');
      const src = params.get('src');

      if (utmSource) {
        const normalizado = utmSource.toLowerCase();
        if (normalizado.includes('instagram')) origem = 'instagram';
        else if (normalizado.includes('whatsapp')) origem = 'whatsapp';
        else if (normalizado.includes('facebook') || normalizado.includes('fb')) origem = 'facebook';
        else if (normalizado.includes('tiktok')) origem = 'tiktok';
        else if (normalizado.includes('google')) origem = 'google';
        else if (normalizado.includes('twitter') || normalizado.includes('x.com')) origem = 'twitter';
        else if (normalizado.includes('qrcode') || normalizado.includes('qr')) origem = 'qrcode';
        else origem = 'outro';
      } else if (src) {
        const normalizado = src.toLowerCase();
        if (normalizado.includes('qrcode') || normalizado.includes('qr')) origem = 'qrcode';
        else origem = 'outro';
      } else if (document.referrer) {
        try {
          const url = new URL(document.referrer);
          const hostname = url.hostname.replace(/^www\./, '');
          origem = this.REFERRER_MAP[hostname] || 'outro';
        } catch (e) {
          origem = 'outro';
        }
      }
    } catch (e) {}

    try {
      sessionStorage.setItem(this.CHAVE_ORIGEM, origem);
    } catch (e) {}

    return origem;
  }

  private detectarDispositivo(): string {
    try {
      const ua = navigator.userAgent;
      if (/iPad/.test(ua)) return 'iPad';
      if (/iPhone/.test(ua)) return 'iPhone';
      if (/Android/i.test(ua)) return 'Android';
      if (/Windows/i.test(ua)) return 'Windows';
      if (/Macintosh|Mac OS/i.test(ua)) return 'Mac';
      if (/Linux/i.test(ua)) return 'Linux';
      return 'Outro';
    } catch (e) {
      return 'Outro';
    }
  }

  private obterReferrer(): string {
    try {
      return document.referrer || '';
    } catch (e) {
      return '';
    }
  }

  private obterParametroUrl(nome: string): string {
    try {
      const params = new URLSearchParams(window.location.search);
      return params.get(nome) || '';
    } catch (e) {
      return '';
    }
  }

  private obterUserAgent(): string {
    try {
      return navigator.userAgent || '';
    } catch (e) {
      return '';
    }
  }

  private gerarUUID(): string {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      return crypto.randomUUID();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  private enviarEvento(slug: string, data: any): void {
    const url = `/api/bio/${slug}/event`;
    const corpo = JSON.stringify(data);

    try {
      if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
        const blob = new Blob([corpo], {type: 'application/json'});
        const sent = navigator.sendBeacon(url, blob);
        if (sent) return;
      }
    } catch (e) {}

    try {
      fetch(url, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: corpo,
        keepalive: true
      }).catch(() => {});
    } catch (e) {}
  }

  private ehAdmin(): boolean {
    try {
      if (typeof window !== 'undefined' && window.location.pathname.indexOf('/admin') >= 0) {
        return true;
      }
      if (typeof localStorage !== 'undefined' && localStorage.getItem('bio_admin_preview')) {
        return true;
      }
    } catch (e) {}
    return false;
  }
}
